import { useMemo } from 'react';

import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';

import { getFiltersConfiguration } from 'app/modules/Wishlist/config/filters';
import useDataTableContext from 'app/components/DataTable/context/DataTableContext';

export const useFiltersConfiguration = () => {
  const intl = useIntl();
  const formik = useFormikContext();
  const {
    api: { apiResponse }
  } = useDataTableContext();
  const maxValues = useMemo(
    () => apiResponse?.meta || null,
    [apiResponse?.meta]
  );

  const completeConfiguration = useMemo(
    () =>
      getFiltersConfiguration({
        intl,
        formik,
        maxValues
      }),
    [formik, intl, maxValues]
  );

  const getComponentFilter = (targetFilter) =>
    completeConfiguration.find((filter) => filter.value === targetFilter)
      .component;

  const getOptionsToSelect = () =>
    completeConfiguration.map(({ component, ...filter }) => filter);

  return {
    completeConfiguration,
    getComponentFilter,
    getOptionsToSelect
  };
};
